/** @format */
import useQuoteStore from "../store/QuoteStore";
import { removePound } from "../../../shared/utils/formatters";
import { updateQuoteFields } from "../../../shared/utils/storeUtils";

const QuoteUpdateMapper = {
  get() {
    const quoteData = useQuoteStore?.getState()?.quote;
    if (quoteData) {
      return {
        volAccess: quoteData?.cover?.requestedVolAccessId || "",
        coverLevel: quoteData?.vehicles?.[0]?.coverTypeId || "",
      };
    }
    return this.defaultValues;
  },

  set(data) {
    updateQuoteFields({
      "risk.cover.requestedVolExcessId": data.volAccess?.value,
      "risk.cover.requestedVolExcess": removePound(data.volAccess?.label),
      "risk.vehicles.0.coverTypeId": data.coverLevel?.value,
    });
  },
};

export default QuoteUpdateMapper;
